import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getManagerApproveEarlyRegisterStart,
  getManagerApproveEarlyRegisterSuccess,
  getManagerApproveEarlyRegisterFailed,
} from "../redux/getManagerApproveEarlyRegister";
import { getManagerApproveEarlyRegisterApi } from "core/http/service/timeKeeping";
import { SCREEN } from "helper/roleChecker/Screens";
import { setEarlyRegistrationFormInput } from "../redux/earlyRegistation";

function* getManagerApproveEarlyRegisterWork() {
  try {
    const res = yield call(
      getManagerApproveEarlyRegisterApi,
      SCREEN.IP_016,
      {}
    );

    yield put({
      type: getManagerApproveEarlyRegisterSuccess.type,
      payload: res?.map((it) => ({
        label: `${it?.name} - ${it?.positionName}`,
        value: it?.employeeCode,
      })),
    });

    yield put({
      type: setEarlyRegistrationFormInput.type,
      payload: {
        approvals: res?.map((it) => ({
          label: `${it?.name} - ${it?.positionName}`,
          value: it?.employeeCode,
        })),
      },
    });
  } catch (error: any) {
    yield put({
      type: getManagerApproveEarlyRegisterFailed.type,
    });
  }
}

function* watchGetManagerApproveEarlyRegister() {
  yield takeLatest(
    getManagerApproveEarlyRegisterStart.type,
    getManagerApproveEarlyRegisterWork
  );
}

export default function* getManagerApproveEarlyRegisterSaga() {
  yield all([watchGetManagerApproveEarlyRegister()]);
}
